import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { RespostaPesquisaRequestModel } from '@shared/models/backend'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class PesquisaSatisfacaoService {
  constructor(private http: HttpClient) {}

  save(form: RespostaPesquisaRequestModel) {
    return this.http.post<RespostaPesquisaRequestModel>('/api/pesquisa-satisfacao/respostas', form).pipe(take(1))
  }

  getDisponivel(): Observable<boolean> {
    return this.http.get<boolean>('/api/pesquisa-satisfacao/disponivel').pipe(take(1))
  }
}
